"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakingToggleRuleButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const updateRule_json_1 = __importDefault(require("@framework/abis/json/Ponzi/updateRule.json"));
const StakingToggleRuleButton = (props) => {
    const { className, disabled, rule, variant } = props;
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { execute: metaToggleRule } = (0, react_hooks_eth_1.useMetamask)(async (rule) => {
        const ruleStatus = rule.stakingRuleStatus !== types_1.StakingRuleStatus.ACTIVE;
        return writeContractAsync({
            address: rule.contract.address,
            abi: updateRule_json_1.default,
            functionName: "updateRule",
            args: [rule.externalId || 0, ruleStatus],
        });
    });
    const handleToggleRule = (rule) => {
        return () => {
            return metaToggleRule(rule);
        };
    };
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleToggleRule(rule), icon: rule.stakingRuleStatus === types_1.StakingRuleStatus.ACTIVE ? icons_material_1.PauseCircleOutline : icons_material_1.PlayCircleOutline, message: rule.stakingRuleStatus === types_1.StakingRuleStatus.ACTIVE
            ? "pages.staking.rules.deactivate"
            : "pages.staking.rules.activate", className: className, dataTestId: "StakeToggleRuleButton", disabled: disabled || rule.stakingRuleStatus === types_1.StakingRuleStatus.NEW, variant: variant }));
};
exports.StakingToggleRuleButton = StakingToggleRuleButton;
//# sourceMappingURL=index.js.map